import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectComponent } from '@epd/pattern-library';
import { filter } from 'rxjs';

import { SAMPLE_PROMPTS, SamplePromptGroup } from './sample-prompts.config';

@Component({
    selector: 'craig-streaming-prompt-ideas',
    templateUrl: './sample-prompt.component.html',
    styleUrl: './sample-prompt.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SamplePromptComponent implements OnInit, AfterViewInit {
    @Output() promptUpdated: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild('dropdownComponent') promptDropdown!: SelectComponent;

    promptForm: FormGroup = new FormGroup({
        prompt: new FormControl('')
    });
    samplePromptGroups: SamplePromptGroup[] = SAMPLE_PROMPTS;

    ngOnInit(): void {
        this.promptForm
            .get('prompt')
            ?.valueChanges.pipe(filter((promptValue: string) => !!promptValue))
            .subscribe((promptValue: string) => {
                this.promptUpdated.emit(promptValue);
            });
    }

    ngAfterViewInit(): void {
        // Workaround to avoid dropdown selection
        if (this.promptDropdown) {
            const onPromptDropdwonItemClick: (value: string) => void =
                this.promptDropdown.selectComponent.onItemClick.bind(this.promptDropdown.selectComponent);

            this.promptDropdown.selectComponent.onItemClick = (value: string): void => {
                onPromptDropdwonItemClick(value);
                this.promptDropdown.selectComponent.onClearSelection();
            };
        }
    }

    selectSamplePromptText(selectedText: string): void {
        this.promptForm.get('prompt')?.setValue(selectedText);
    }
}
